(() => {
  const PHONE = '593979649314';

  const money = (cents, currency = 'USD') => {
    try {
      return new Intl.NumberFormat('es-EC', {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const getOfferName = (cart) => {
    if (cart.item_count === 1 && cart.total_price === 44700) {
      return 'Compra Individual — 1 carrito por $447';
    }

    if (cart.item_count === 2 && cart.total_price === 85700) {
      return 'Compra Familiar — 2 carritos por $857';
    }

    return `Pedido del carrito por ${money(cart.total_price, cart.currency)}`;
  };

  // Shopify puede separar en dos líneas un mismo producto cuando un descuento
  // se aplica solamente a una de las unidades. Para WhatsApp agrupamos esas
  // líneas nuevamente por variante, sin alterar el carrito ni el descuento.
  const groupCartItems = (items) => {
    const grouped = new Map();

    items.forEach((item) => {
      const key = String(item.variant_id || item.key || item.id);
      const existing = grouped.get(key);

      if (existing) {
        existing.quantity += Number(item.quantity || 0);
        existing.finalLinePrice += Number(item.final_line_price || 0);
        existing.originalLinePrice += Number(
          item.original_line_price || item.final_line_price || 0
        );
        return;
      }

      grouped.set(key, {
        productTitle: item.product_title || item.title || 'Producto',
        variantTitle:
          item.variant_title && item.variant_title !== 'Default Title'
            ? item.variant_title
            : '',
        quantity: Number(item.quantity || 0),
        finalLinePrice: Number(item.final_line_price || 0),
        originalLinePrice: Number(
          item.original_line_price || item.final_line_price || 0
        )
      });
    });

    return Array.from(grouped.values());
  };

  const buildMessage = (cart) => {
    const groupedItems = groupCartItems(cart.items || []);

    const lines = [
      'Hola, quiero realizar este pedido en Turbo Toys:',
      '',
      `Oferta seleccionada: ${getOfferName(cart)}`,
      ''
    ];

    groupedItems.forEach((item) => {
      const variant = item.variantTitle ? ` — ${item.variantTitle}` : '';

      lines.push(`Producto: ${item.productTitle}${variant}`);
      lines.push(`Cantidad: ${item.quantity}`);
      lines.push(`Subtotal: ${money(item.finalLinePrice, cart.currency)}`);
      lines.push('');
    });

    if (Number(cart.total_discount || 0) > 0) {
      lines.push(
        `Descuento aplicado: -${money(
          cart.total_discount,
          cart.currency
        )}`
      );
    }

    lines.push(`Total: ${money(cart.total_price, cart.currency)}`);
    lines.push('');
    lines.push(
      '¿Está disponible? También quisiera confirmar el envío y la forma de pago.'
    );

    return lines.join('\n');
  };

  const trackWhatsAppContact = (cart) => {
    try {
      if (
        window.Shopify &&
        Shopify.analytics &&
        typeof Shopify.analytics.publish === 'function'
      ) {
        Shopify.analytics.publish('turbotoys:whatsapp_contact', {
          contact_method: 'whatsapp',
          whatsapp_location: 'carrito',
          product_title: getOfferName(cart),
          product_url: window.location.href
        });
      }
    } catch (trackingError) {
      console.warn(
        '[Turbo Toys Tracking] No se pudo registrar el contacto de WhatsApp.',
        trackingError
      );
    }
  };

  const trackWhatsAppCheckout = (cart) => {
    try {
      if (
        window.Shopify &&
        Shopify.analytics &&
        typeof Shopify.analytics.publish === 'function'
      ) {
        const groupedItems = groupCartItems(cart.items || []);

        Shopify.analytics.publish('turbotoys:whatsapp_checkout', {
          checkout_method: 'whatsapp',
          whatsapp_location: 'carrito',
          value: Number(cart.total_price || 0) / 100,
          currency: cart.currency || 'USD',
          num_items: Number(cart.item_count || 0),
          content_ids: (cart.items || []).map((item) =>
            String(item.variant_id || item.id || '')
          ),
          contents: groupedItems.map((item) => ({
            product_title: item.productTitle,
            variant_title: item.variantTitle,
            quantity: item.quantity
          })),
          offer_name: getOfferName(cart),
          page_url: window.location.href
        });
      }
    } catch (trackingError) {
      console.warn(
        '[Turbo Toys Tracking] No se pudo registrar el inicio de checkout por WhatsApp.',
        trackingError
      );
    }
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-whatsapp-cart-checkout]');

    if (!button) return;

    event.preventDefault();

    if (
      button.disabled ||
      button.getAttribute('aria-busy') === 'true'
    ) {
      return;
    }

    const label = button.querySelector('.button__label');
    const originalText = label?.textContent || button.textContent;

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    if (label) {
      label.textContent = 'PREPARANDO PEDIDO…';
    }

    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${root}cart.js`, {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!response.ok) {
        throw new Error('No se pudo leer el carrito.');
      }

      const cart = await response.json();

      if (!Array.isArray(cart.items) || cart.items.length === 0) {
        throw new Error('El carrito está vacío.');
      }

      const message = buildMessage(cart);

      const url =
        `https://wa.me/${PHONE}?text=${encodeURIComponent(message)}`; 
 
      // Mantener el evento Contactar que ya funciona. 
      trackWhatsAppContact(cart); 
 
      // Nueva señal de alta intención: inicio de checkout por WhatsApp. 
      trackWhatsAppCheckout(cart); 
 
      // Abrir WhatsApp sin alterar la lógica del carrito. 
      window.open( 
        url, 
        '_blank', 
        'noopener,noreferrer' 
      ); 
 
    } catch (error) { 
      console.error('[Turbo Toys WhatsApp]', error); 
 
      alert( 
        'No pudimos preparar el pedido. Actualiza la página e inténtalo nuevamente.' 
      ); 
 
    } finally { 
      button.removeAttribute('aria-busy'); 
      button.disabled = false; 
 
      if (label) { 
        label.textContent = originalText.trim(); 
      } 
    } 
  }); 
})();